import reqEnum from '../../utils/request-statuses';

export const getFirmwares = state => state.firmwares.firmwares;
export const firmwaresStatus = state => state.firmwares.status;
export const firmwaresLoadingInProgress = state => state.firmwares.status === reqEnum.loading;
export const firmwaresError = state => state.firmwares.error;
export const getPager = state => state.firmwares.pager;  